/*
------------------------------------------------------------------------------------
propAry配列で登録しているJSON内の画像ファイル名記述（【…】の半角文字）からリンクパスを取得し置換
------------------------------------------------------------------------------------
*/

function setImageLink(questions) {
	var i, j;
	var propAry = ["text", "answer", "explanation"]; // drill.jsonからHTMLテキスト向けの変換を行うJSON内プロパティ名を配列で登録

	for (i = 0; i < propAry.length; i++) {
		if(typeof questions[propAry[i]] === 'object') 
			questions[propAry[i]] = questions[propAry[i]].join(" ")
		if (questions[propAry[i]].match(/【[\\.\x20-\x7F]+?】/g)) {
			var imgFile = questions[propAry[i]].match(/【[\\.\x20-\x7F]+?】/g);
			for (j = 0; j < imgFile.length; j++) {
				var removePalen = imgFile[j].replace(/[【】]+/g, "");
				var getImgPath = require('@/assets/img/'+removePalen);
				var reObj = new RegExp(imgFile[j]);
				questions[propAry[i]] = questions[propAry[i]].replace(reObj, "<img src='"+getImgPath+"' alt=''>");
			}
		}
	}
	return questions;
}
export default {setImageLink}